<button
  mat-button
  [matTooltip]="'Loading...'"
  class="create-quick-action w-100 quick-action app-border"
>
  <button
    mat-icon-button
    class="quick-action_icon skeleton-loader-item"
    disabled
  >
    <mat-icon class="mr-2" style="margin-left: 1.2rem"></mat-icon>
  </button>
  <strong class="quick-action-title skeleton-loader-item"></strong>
  <button
    mat-icon-button
    class="quick-action_drag skeleton-loader-item"
    disabled
  >
    <mat-icon></mat-icon>
  </button>
</button>
